import Permission from './Permission';

export enum PermissionAction {
  UPDATE_KAIZEN_USER_CREDIT_CARD = 'UPDATE_KAIZEN_USER_CREDIT_CARD',
  CREATE_POINT_APPLICATION = 'CREATE_POINT_APPLICATION',
  POINT_AVAILABLE_REGION = 'POINT_AVAILABLE_REGION',
}

const AVAILABLE_PERMISSION_ACTION = Object.keys(PermissionAction);

class AcctAccount {
  public readonly kaizenUserId: string;
  public readonly permissions: Permission<PermissionAction>[];
  public readonly companyName: string;
  public readonly departmentName: string;
  constructor({
    kaizenUserId,
    permissions,
    companyName,
    departmentName,
  }: {
    kaizenUserId: string;
    permissions: Permission<PermissionAction>[];
    companyName: string;
    departmentName: string;
  }) {
    this.kaizenUserId = kaizenUserId;
    this.permissions = permissions;
    this.companyName = companyName;
    this.departmentName = departmentName;
  }

  public hasPermission = (pa: PermissionAction) => {
    const pp = this.permissions.find((p: Permission<PermissionAction>) => p.action === pa);
    return pp && pp.permission;
  };

  public static fromJSON = (value: any) => {
    const { kaizen_user_id, permissions, company_name, department_name } = Object.assign({}, value);
    const kaizenUserId = String(kaizen_user_id);
    const companyName = String(company_name);
    const departmentName = String(department_name);

    if (typeof kaizenUserId !== 'string') throw new TypeError('.kaizenUserId must be a string');
    if (typeof permissions !== 'object') throw new TypeError('.permissions must be an object');
    if (typeof companyName !== 'string') throw new TypeError('.companyName must be a string');
    if (typeof departmentName !== 'string') throw new TypeError('.departmentName must be a string');

    return new AcctAccount({
      kaizenUserId,
      permissions: Object.keys(permissions).map((k: string) =>
        Permission.fromJSON(
          { action: k.toUpperCase(), permission: permissions[k].permit },
          AVAILABLE_PERMISSION_ACTION,
        ),
      ),
      companyName,
      departmentName,
    });
  };
}

export default AcctAccount;
